module.exports = __webpack_public_path__ + "assets/img/afu-dapnet-logo.c1d1257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afu-dapnet-logo.png
// module id = OHgS
// module chunks = 1